var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    ("theme-" + (_vm.theme.toLowerCase())),
    _vm.$route.name === 'CFP' ? 'cfp' : 'main',
    _vm.isInApp() ? 'in-app' : '',
    _vm.isPopup ? 'popuped' : ''
  ],attrs:{"id":"app"}},[(_vm.$route.name !== 'CFP' && !_vm.isInApp())?_c('Navbar'):_vm._e(),_c('Popup',{attrs:{"isOpen":_vm.isPopup,"content":_vm.popupContent}}),_c('transition',{attrs:{"name":_vm.transitionDirect.toLowerCase()}},[_c('keep-alive',[_c('router-view',{staticClass:"transition-group"})],1)],1),_c('SponsorFooter',{class:{ 'blur-filter': _vm.$route.name === 'Home' }}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }